import {VERSION_ID} from "../env";

// noinspection JSUnresolvedVariable
export default "custom-form/v2-" + VERSION_ID;
